import { ChangeEvent } from 'react';

/**
 * Reads the current text value from a Combobox/input change event, defaulting
 * to an empty string when the event or its target is missing (e.g. when the
 * field clears its input).
 */
export default function getInputEventValue(event?: ChangeEvent): string {
  return (event?.target as HTMLInputElement | undefined)?.value ?? '';
}
